import { ProjectListRes } from '../../api/MaterialApi'

// success为接口调用成功
// msg = '1'  关联项目不一致
// msg = '2'  非该物料的导入模板
export type ImportExcelErrorType = '1' | '2' | 'success'
interface State {
  relationProjectList: ProjectListRes[]
  formData: any
  importExcelErrorType?: ImportExcelErrorType
  showResult: boolean
  isImportLoading: boolean
  // msg = '1'  关联项目不一致
  // msg = '2'  非该物料的导入模板
}
type ActionType =
  | 'setFormDataAction'
  | 'resetStateAction'
  | 'setRelationProjectListAction'
  | 'setImportExcelErrorTypeAction'
  | 'setShowResultAction'
  | 'setIsImportLoadingAction'

interface Action {
  type: ActionType
  payload: any
}

const initialState: State = {
  formData: {},
  relationProjectList: [],
  importExcelErrorType: undefined,
  showResult: false,
  isImportLoading: false,
}

export default function reducer(
  state: State = initialState,
  action: Action,
): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setFormDataAction':
      newstate.formData = action.payload
      return newstate
    case 'setRelationProjectListAction':
      newstate.relationProjectList = action.payload
      return newstate
    case 'setImportExcelErrorTypeAction':
      newstate.importExcelErrorType = action.payload
      return newstate
    case 'setShowResultAction':
      newstate.showResult = action.payload
      return newstate
    case 'setIsImportLoadingAction':
      newstate.isImportLoading = action.payload
      return newstate
    case 'resetStateAction':
      return initialState
    default:
      return newstate
  }
}

/**
 * 保存表单数据
 * @param val
 * @returns
 */
export const setFormDataAction = (val: any): Action => ({
  type: 'setFormDataAction',
  payload: val,
})

export const setRelationProjectListAction = (
  val: ProjectListRes[],
): Action => ({
  type: 'setRelationProjectListAction',
  payload: val,
})

export const setImportExcelErrorTypeAction = (
  val?: ImportExcelErrorType,
): Action => ({
  type: 'setImportExcelErrorTypeAction',
  payload: val,
})

export const setShowResultAction = (val: boolean): Action => ({
  type: 'setShowResultAction',
  payload: val,
})

export const setIsImportLoadingAction = (val: boolean): Action => ({
  type: 'setIsImportLoadingAction',
  payload: val,
})

/**
 * 重置redux内容，关闭页面时调用
 * @returns
 */
export const resetStateAction = (): Action => ({
  type: 'resetStateAction',
  payload: undefined,
})
import { ProjectListRes } from '../../api/MaterialApi'

// success为接口调用成功
// msg = '1'  关联项目不一致
// msg = '2'  非该物料的导入模板
export type ImportExcelErrorType = '1' | '2' | 'success'
interface State {
  relationProjectList: ProjectListRes[]
  formData: any
  importExcelErrorType?: ImportExcelErrorType
  showResult: boolean
  isImportLoading: boolean
  // msg = '1'  关联项目不一致
  // msg = '2'  非该物料的导入模板
}
type ActionType =
  | 'setFormDataAction'
  | 'resetStateAction'
  | 'setRelationProjectListAction'
  | 'setImportExcelErrorTypeAction'
  | 'setShowResultAction'
  | 'setIsImportLoadingAction'

interface Action {
  type: ActionType
  payload: any
}

const initialState: State = {
  formData: {},
  relationProjectList: [],
  importExcelErrorType: undefined,
  showResult: false,
  isImportLoading: false,
}

export default function reducer(
  state: State = initialState,
  action: Action,
): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setFormDataAction':
      newstate.formData = action.payload
      return newstate
    case 'setRelationProjectListAction':
      newstate.relationProjectList = action.payload
      return newstate
    case 'setImportExcelErrorTypeAction':
      newstate.importExcelErrorType = action.payload
      return newstate
    case 'setShowResultAction':
      newstate.showResult = action.payload
      return newstate
    case 'setIsImportLoadingAction':
      newstate.isImportLoading = action.payload
      return newstate
    case 'resetStateAction':
      return initialState
    default:
      return newstate
  }
}

/**
 * 保存表单数据
 * @param val
 * @returns
 */
export const setFormDataAction = (val: any): Action => ({
  type: 'setFormDataAction',
  payload: val,
})

export const setRelationProjectListAction = (
  val: ProjectListRes[],
): Action => ({
  type: 'setRelationProjectListAction',
  payload: val,
})

export const setImportExcelErrorTypeAction = (
  val?: ImportExcelErrorType,
): Action => ({
  type: 'setImportExcelErrorTypeAction',
  payload: val,
})

export const setShowResultAction = (val: boolean): Action => ({
  type: 'setShowResultAction',
  payload: val,
})

export const setIsImportLoadingAction = (val: boolean): Action => ({
  type: 'setIsImportLoadingAction',
  payload: val,
})

/**
 * 重置redux内容，关闭页面时调用
 * @returns
 */
export const resetStateAction = (): Action => ({
  type: 'resetStateAction',
  payload: undefined,
})
